export default __webpack_public_path__ + "static/media/532.c5e9fbf2.png";